/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Identity_CtaInputs */

const en_identity_cta = /** @type {(inputs: Identity_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What struggle?`)
};

const de_identity_cta = /** @type {(inputs: Identity_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welches Problem?`)
};

const zh_tw_identity_cta = /** @type {(inputs: Identity_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`什麼困擾？`)
};

const zh_cn_identity_cta = /** @type {(inputs: Identity_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`什么困扰？`)
};

const es_identity_cta = /** @type {(inputs: Identity_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuál es?`)
};

const fr_identity_cta = /** @type {(inputs: Identity_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laquelle ?`)
};

const it_identity_cta = /** @type {(inputs: Identity_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quale problema?`)
};

const pt_br_identity_cta = /** @type {(inputs: Identity_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual desafio?`)
};

const ja_identity_cta = /** @type {(inputs: Identity_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`どんな悩み？`)
};

const ko_identity_cta = /** @type {(inputs: Identity_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`무슨 고민인데요?`)
};

const ru_identity_cta = /** @type {(inputs: Identity_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Какой проблемой?`)
};

const th_identity_cta = /** @type {(inputs: Identity_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ปัญหาอะไร?`)
};

const tr_identity_cta = /** @type {(inputs: Identity_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ne sorunu?`)
};

const ar_identity_cta = /** @type {(inputs: Identity_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ما المشكلة؟`)
};

/**
* | output |
* | --- |
* | "What struggle?" |
*
* @param {Identity_CtaInputs} inputs
* @param {{ locale?: "en" | "de" | "zh_tw" | "zh_cn" | "es" | "fr" | "it" | "pt_br" | "ja" | "ko" | "ru" | "th" | "tr" | "ar" }} options
* @returns {LocalizedString}
*/
export const identity_cta = /** @type {((inputs?: Identity_CtaInputs, options?: { locale?: "en" | "de" | "zh_tw" | "zh_cn" | "es" | "fr" | "it" | "pt_br" | "ja" | "ko" | "ru" | "th" | "tr" | "ar" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Identity_CtaInputs, { locale?: "en" | "de" | "zh_tw" | "zh_cn" | "es" | "fr" | "it" | "pt_br" | "ja" | "ko" | "ru" | "th" | "tr" | "ar" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_identity_cta(inputs)
	if (locale === "de") return de_identity_cta(inputs)
	if (locale === "zh_tw") return zh_tw_identity_cta(inputs)
	if (locale === "zh_cn") return zh_cn_identity_cta(inputs)
	if (locale === "es") return es_identity_cta(inputs)
	if (locale === "fr") return fr_identity_cta(inputs)
	if (locale === "it") return it_identity_cta(inputs)
	if (locale === "pt_br") return pt_br_identity_cta(inputs)
	if (locale === "ja") return ja_identity_cta(inputs)
	if (locale === "ko") return ko_identity_cta(inputs)
	if (locale === "ru") return ru_identity_cta(inputs)
	if (locale === "th") return th_identity_cta(inputs)
	if (locale === "tr") return tr_identity_cta(inputs)
	return ar_identity_cta(inputs)
});